<style>
</style>

<template>
  <v-app>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :multi-line="false"
      :timeout="snackbarTimeout"
    >
      {{ snackbarMessage }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-container fill-height>
      <v-card width="400" class="mx-auto mt-5 mb-12">
        <v-card-title class="deep-orange white--text">
          <h2>Password reset</h2>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation @keyup.native.enter="validate">
            <v-text-field
              label="Reset token"
              v-model="token"
              :rules="tokenRules"
              prepend-icon="mdi-key"
              required
            />
            <v-text-field
              label="Email address"
              v-model="email"
              prepend-icon="mdi-account"
              required
              readonly
            />
            <v-alert dense outlined type="info" color="deep-orange">
              The password must contain at least 1 upper case letter, 1 lower case letter,
              1 number or special character and 8 characters in length
            </v-alert>
            <v-text-field
              :type="showPassword ? 'text' : 'password'"
              v-model="newPassword"
              :rules="newPasswordRules"
              label="New password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            />
            <v-text-field
              :type="showPassword ? 'text' : 'password'"
              v-model="newPasswordConfirm"
              :error-messages="newPasswordConfirmErrors"
              label="Confirm new password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn :disabled="!valid" color="deep-orange white--text" class="mr-4" @click="validate">
            <v-icon>mdi-lock-reset</v-icon>Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "PasswordReset",
  components: {},
  props: {
    prefillEmail: {
      type: String,
      default: null
    },
    prefillToken: {
      type: String,
      default: null
    },
  },
  watch: {
    prefillEmail: function(value) {
      this.email = value;
    },
    prefillToken: function(value) {
      this.token = value;
    },
  },
  data: () => ({
    valid: false,
    snackbar: false,
    snackbarColor: "red darken-3",
    snackbarTimeout: 6000,
    snackbarMessage: "",
    email: "",
    token: "",
    tokenRules: [
      v => !!v || "Token is required",
      v =>
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
          v
        ) || "Token must be valid"
    ],
    newPassword: "",
    newPasswordConfirm: "",
    newPasswordRules: [
      v => !!v || "New password is required",
      v =>
        /^(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(
          v
        ) || "Password must be valid"
    ],
    showPassword: false
  }),
  computed: {
    newPasswordConfirmErrors() {
      const errors = []
      this.newPasswordConfirm == this.newPassword || errors.push("Password fields didn't match");
      return errors;
    },
  },
  created() {
    this.email = this.prefillEmail;
    this.token = this.prefillToken;
    this.$vuetify.theme.dark = this.$store.state.themeDarkEnabled;
  },
  methods: {
    displayError(message) {
      this.snackbarMessage = message;
      this.snackbar = true;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.$axios
          .put("/users/" + this.email + "/password", {
            token: this.token,
            new_password: this.newPassword
          })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(result => {
            if (
              result.response.data.error &&
              result.response.data.error.message
            ) {
              this.displayError(result.response.data.error.message);
            } else {
              this.displayError(result.message);
            }
          });
      }
    }
  }
};
</script>
